import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const phrases = ['Memorable Events', 'Timeless Moments', 'Cherished Memories', 'Extraordinary Experiences'];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Start fade out
      setIsVisible(false);
      // Change phrase after fade out completes
      setTimeout(() => {
        setCurrentPhraseIndex(prevIndex => (prevIndex + 1) % phrases.length);
        // Start fade in
        setIsVisible(true);
      }, 500); // Half a second for fade out
    }, 6000); // Changed from 3000 to 6000 - now changes every 6 seconds
    return () => clearInterval(intervalId);
  }, []);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="relative bg-indigo-100 pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <motion.div className="lg:grid lg:grid-cols-12 lg:gap-8" initial="hidden" animate="visible" variants={containerVariants} data-id="element-176">
          <motion.div className="lg:col-span-6 xl:col-span-5 flex flex-col justify-center" variants={itemVariants} data-id="element-177">
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl" data-id="element-178">
              <span className="block" data-id="element-179">Create</span>
              <span className={`block text-purple-600 transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} style={{
              minHeight: '1.25em'
            }} // Prevent layout shift
            data-id="element-180">
                {phrases[currentPhraseIndex]}
              </span>
              <span className="block" data-id="element-181">with Turnout</span>
            </h1>
            <p className="mt-3 text-base text-gray-700 sm:mt-5 sm:text-lg" data-id="element-182">
              We transform your vision into extraordinary events. From corporate
              conferences to weddings, our team delivers exceptional experiences
              that leave lasting impressions.
            </p>
            <div className="mt-8 sm:mt-10" data-id="element-183">
              <a href="https://calendly.com/dan-the-academi/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-300" data-id="element-184">
                Get Started
              </a>
            </div>
          </motion.div>
          <motion.div className="mt-12 lg:mt-0 lg:col-span-6 xl:col-span-7" variants={itemVariants} data-id="element-185">
            <div className="relative h-64 sm:h-72 md:h-96 lg:h-full" data-id="element-186">
              <img className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-xl" src="https://uploadthingy.s3.us-west-1.amazonaws.com/nkejvN6BgivE9cw2PiAakN/1726242026756_%281%29.jpg" alt="Group gathering on a rooftop at sunset" data-id="element-187" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}